// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectAlgorithmMessageBase } from './DirectAlgorithmMessageBase';
import { Message } from '../Message';
export class DirectAlgorithmTopVolumeMessage extends DirectAlgorithmMessageBase {
    constructor() {
        super(Message.CODE_PFIX_ALGORITHM_TOP_VOLUME_MESSAGE);
        // AlgorithmId = -1;                               // 694 - creating in DirectAlgorithmMessageBase
        // AlgorithmName = null;                           // 696 - creating in DirectAlgorithmMessageBase
        this.AlgorithmTop = null; // 700 - (int)
        this.AlgorithmTopVolumeDataGroups = null; // 104 - группа инструментов для юзеров с RT датой.
        this.AlgorithmTopVolumeDelayDataGroups = null; // 105 - группа инструментов для юзеров с Delay data.
        this.AlgorithmTopVolumeInstrumentGroups = null; // 106
    }
}
